import type { GetUserEnrollmentsQueryVariables } from '../../graphql/types/GetUserEnrollmentsQuery';

export const DEFAULT_COURSE_ENROLLMENTS_QUERY_VARIABLES: GetUserEnrollmentsQueryVariables =
  {
    first: 12,
  };
